<template>
  <div
    class="spinner-grow d-flex justify-content-center"
    style="margin: auto"
    role="status"
  >
    <span class="sr-only"></span>
  </div>
</template>
